<div class="w-100 wrapper-sezione-mappe">
    <div class="mappa-sensori-wrapper">
        <!-- Filtro sensori -->
        <div class="sensor-filter-container d-flex">
            <div class="w-100 d-flex flex-column justify-content-center pt-2">
                <div class="form-floating d-flex align-items-center select-wrapper mr-2 mb-2">
                    <!-- <label for="select-tipo">Filtra tipo sensore</label> -->
                    <select class="custom-select" id="select-tipo" aria-label="Tipo sensore"
                        [(ngModel)]="selectedSensorType" (change)="onSensorTypeFilterChange()">
                        <option value="all" selected>Tutti i dati</option>
                        <option value="barometri">Pressione atmosferica</option>
                        <option value="idrometri">Livello idrometrico</option>
                        <option value="igrometri">Umidità relativa</option>
                        <option value="pluviometri">Precipitazione</option>
                        <option value="radiometri">Radiazione solare</option>
                        <option value="termometri">Temperatura</option>
                        <option value="ventoraffica">Velocità del Vento di Raffica</option>
                        <option value="ventoscalare">Velocità del Vento Media</option>
                    </select>
                </div>
                <div class="form-floating d-flex align-items-center select-wrapper mr-2 mb-2">
                    <ng-select class="border-form-cont w-100" [items]="stationListSelect" bindLabel="denominazione"
                        bindValue="idStazione" placeholder="Cerca stazione" [(ngModel)]="idStazioneSelect"
                        [searchable]="true" (change)="onStationFilterChange()">
                    </ng-select>
                </div>
                <div class="form-floating select-wrapper mr-2 w-100 d-flex justify-content-end" style="height: 30px;">
                    <button class="btn btn-danger m-0 h-100" (click)="showAllMarkers()">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        </div>
        <!-- Div per i dettagli della stazione e l'elenco dei sensori -->
        <div class="overlay-container">
            <!-- Elenco dei sensori -->
            <div *ngIf="sensorList && sensorList?.length > 0" class="card" style="margin-bottom: 0;">
                <div class="card-header header-sensori d-flex align-item-center justify-content-between">
                    <span class="pr-2" style="font-size: 1rem;align-self: center">Elenco dei Sensori</span>
                    <button type="button" class="close-sensori close ml-2" (click)="closeSensorList()">
                        <span aria-hidden="true" style="font-size: 2.5rem; line-height: 1;">&times;</span>
                    </button>
                </div>
                <div class="sensor-list pb-2" style="min-height: 50px; max-height: 400px;">
                    <ul class="list-group list-group-flush" style="overflow: auto !important;">
                        <li class="list-group-item"
                            style="cursor: pointer; padding-top: 5px !important; padding-bottom: 5px !important;min-height: 60px;"
                            *ngFor="let sensor of sensorList; let k = index;" (click)="openSensorDownload(sensor)">
                            <div class="w-100 h-100 d-flex flex-column justify-content-center" style="cursor: pointer;">
                                <div class="w-100">
                                    <span class="sensori-list">{{ sensor.idSensore || "" }} - {{sensor.nome ||
                                        ""}}</span>
                                </div>
                                <div class="w-100">
                                    <span class="sensori-tipo">{{getFriendlyName(sensor.tipoSensore) || ""}}</span>

                                </div>
                            </div>

                        </li>
                    </ul>
                </div>
                <!-- <div class="card-footer">
                    <span class="mb-2" style="font-size: 1rem;"><strong> </strong></span>
                </div> -->
            </div>
        </div>
        <!-- Mappa -->
        <div id="mapDati"></div>
    </div>
</div>
<div class="disclaimer-container">
    <div class="w-100 d-flex justify-content-between px-4">
        <span class="w-25 h4">
            <span class="badge badge-secondary blink">Dati non validati</span>
        </span>
        <div class="d-flex align-items-center">
            <button class="btn btn-primary btn-lg mr-2" 
                    (click)="downloadExcelFile()">
                <i class="fa fa-file-excel mr-2" aria-hidden="true"></i>TABELLA SENSORI
            </button>
            <button class="btn btn-primary btn-lg" 
                    (click)="openPdfDocument()">
                <i class="fa fa-file-pdf mr-2" aria-hidden="true"></i>PDF
            </button>
        </div>
        <div class="switch-tabellare d-flex align-items-center my-2">
            <span class="pr-2">Visualizza tabella</span>
            <div class="pt-2">
                <bSwitch class="pt-1" style="transform: scale(1.4);" [(ngModel)]="isTabella">
                </bSwitch>
            </div>
        </div>
    </div>

    <div *ngIf="isTabella" class="w-100 pt-2 pb-3 px-3 d-flex flex-column justify-content-center">

        <div *ngIf="isTabella" class="w-100 pt-2 pb-1 px-3">
            <!-- Controlli personalizzati per la paginazione -->
            <div class="d-flex align-items-center justify-content-between mb-2">
                <div class="d-flex align-items-center">
                    <label class="mr-2 mb-0">Righe per pagina:</label>
                    <select class="form-control" style="width: auto;" [(ngModel)]="currentPageSize"
                        (change)="changePageSize(+$event.target.value)">
                        <option *ngFor="let size of pageSizeOptions" [value]="size">{{size}}</option>
                    </select>
                </div>
                <div class="text-muted">
                    Totale stazioni: {{dataTabella?.length || 0}}
                </div>
            </div>

            <!-- La tua tabella esistente -->
            <ag-grid-angular [rowData]="dataTabella" [gridOptions]="gridOptions" style="height: 600px; width: 100%;"
                class="ag-theme-alpine" [localeText]="customLocaleText">
            </ag-grid-angular>
        </div>
    </div>
    <div class="container banner-container mb-4 w-100">
        <div class="banner-title"><i class="fa-solid fa-triangle-exclamation mr-1"
                style="color: #FFD43B;"></i>Avvertenza</div>
        <p class="banner-text">
            I dati resi disponibili all’utenza sono quelli grezzi 
            <button type="button" class="info-tps" placement="top" ngbTooltip="Per dato grezzo, proveniente in tempo reale dal sensore remoto, si intende il dato 
misurato dal sensore in situ e inviato direttamente al sistema informatico di raccolta e 
archiviazione, senza alcuna elaborazione, trattamento o analisi; il dato grezzo, quindi, 
anche se di specifico formato, in quanto misura di una determinata grandezza, 
costituisce solo un’informazione elementare corrispettiva di un’operazione di misura, 
che potrebbe essere affetta da errori sistematici o casuali.">(i)</button>
<span class="text-danger">*</span>
            , provenienti in tempo reale dai
            sensori remoti e direttamente immagazzinati nel database delle centrali delle reti di
            monitoraggio; essi, pertanto, non sono sottoposti a procedure o elaborazioni di
            verifica e/o validazione e possono essere differenti da quelli validati e diffusi
            ufficialmente dal Centro Funzionale.<br>
            La Regione Campania, proprietaria dei dati prodotti dalle reti di monitoraggio e
            sorveglianza, gestite dal Centro Funzionale, declina, pertanto, ogni responsabilità
            connessa o conseguente all’uso e/o elaborazione dei dati, che resta in capo
            esclusivamente all’utilizzatore.<br>
            Per comprovate esigenze è disponibile un servizio di validazione accessibile dal link
            riportato in calce alla presente pagina.<br>
            Per altre informazioni e consulenza all’interpretazione e utilizzo dei dati, è possibile
            utilizzare i canali di comunicazione:<br>
            <i class="fa-solid fa-envelope mr-1" style="color: #74C0FC;"></i> &nbsp;
            <a href="mailto:centrofunzionale@regione.campania.it">centrofunzionale@regione.campania.it</a> | <a
                href="mailto:dati.centrofunzionale@pec.regione.campania.it">dati.centrofunzionale@pec.regione.campania.it</a><br>
            <i class="fa-solid fa-phone mr-1" style="color: #ff0000;"></i> 081-2323806<br>
        </p>
            <!-- <a href="/**" class="banner-button text-white">Link alla pagina esterna<br>Dati validati</a> -->
            <div style="width: 100%; align-content: center; display: flex; justify-content: center;">
                <button class="btn btn-success btn-lg" disabled>Link alla pagina esterna<br>Dati validati</button>
            </div>
    </div>


</div>
<!-- <div class="table-wrapper">
    <h4>Elenco delle Stazioni</h4>
    <ag-grid-angular style="width: 100%; height: 500px;" class="ag-theme-alpine" [rowData]="stationList"
        [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" rowSelection="single"></ag-grid-angular>
</div> -->

<ng-template #theModalDetailDati let-modal let-c="close" let-d="dismiss">
    <div class="border-bottom p-3 d-flex justify-content-between align-items-center">
        <span class="h5 m-0" style="float: left; margin-top: 10px;text-transform: uppercase;">
            DETTAGLIO SENSORE {{sensoreToDownload.nome}} - COD.{{ sensoreToDownload.idSensore }} ({{
                    getFriendlyName(sensoreToDownload.tipoSensore) || "" }})

        </span>
        <button type="button" class="close" (click)="closeSingleModal(modal)">
            <span aria-hidden="true" style="font-size: 3rem; line-height: 1;">&times;</span>
        </button>
    </div>
    <div class="modal-body p-0 pb-2 px-2">
        <div class="w-100 m-1">
            <div class="funzioni-wrapper w-100 d-flex flex-column justify-content-center p-3">
                <div style="gap: 4px" class="w-100 d-flex justify-content-center flex-wrap">
                    <button class="btn btn-primary col-md-2 col-sm-12 bottone-nav-form sub d-flex flex-column"
                        [ngClass]="{ 'shadow-selected': tipoVisualizzazione === 1 }" (click)="updateNavigation(1)">
                        <span class="h5 m-0">Sub-giornalieri</span>
                        <span class="h6 m-0 tt-none">Estrazione</span>
                    </button>
                    <div class="d-none d-md-block">
                        <div class="vr"></div>
                    </div>
                    <button class="btn btn-primary col-md-2 col-sm-12 bottone-nav-form d-flex flex-column"
                        [ngClass]="{ 'shadow-selected': tipoVisualizzazione === 2 }" (click)="updateNavigation(2)">
                        <span class="h5 m-0">Giornalieri</span>
                        <span class="h6 m-0 tt-none">Consultazione</span>
                    </button>
                    <button class="btn btn-primary col-md-2 col-sm-12 bottone-nav-form d-flex flex-column"
                        [ngClass]="{ 'shadow-selected': tipoVisualizzazione === 3 }" (click)="updateNavigation(3)">
                        <span class="h5 m-0">Giornalieri</span>
                        <span class="h6 m-0 tt-none">Estrazione</span>
                    </button>
                </div>
            </div>
            <!-- *ngIf="![1, 2, 3, 4].includes(tipoVisualizzazione);else tipoVisualizzazione == 1 ? formSubGiornalieri : formGiornalieri" -->
            <div class="w-100 border mb-2 p-2">
                <ng-container
                    *ngTemplateOutlet=" tipoVisualizzazione == 1 ? formSubGiornalieri : tipoVisualizzazione == 2 ? consultazioneGiornalieri : formGiornalieri"
                    ng></ng-container>
            </div>
        </div>
        <!-- <div class="w-100 d-flex justify-content-center align-items-center">
            <button class="btn btn-primary col-md-2 col-sm-12 bottone-nav-form" (click)="updateNavigation(0)">
                <span class="h5 m-0">Indietro</span>
            </button>
        </div> -->
    </div>
</ng-template>

<!-- Dettaglio sensori tabellare -->
<ng-template #theModalSensori let-modal let-c="close" let-d="dismiss">
    <div class="border-bottom p-3 d-flex justify-content-between align-items-center">
        <span class="h4 m-0" style="float: left; margin-top: 10px;text-transform: uppercase;">
            DETTAGLIO STAZIONE {{ stazioneSelezionata.denominazione }} - {{stazioneSelezionata.comune || ""}} ({{
            stazioneSelezionata.provincia ? stazioneSelezionata.provincia : ""}})
            <!-- {{" " + selectedSensorTypeid || "" }} -->
        </span>
        <button type="button" class="close" (click)="closeSingleModal(modal)">
            <span aria-hidden="true" style="font-size: 3rem; line-height: 1;">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="sensor-list" *ngIf="sensoriToDettaglioTabella.length > 0;">
            <ag-grid-angular [rowData]="sensoriToDettaglioTabella" [gridOptions]="gridOptionsSensori"
                style="height: 600px; width: 100%;" class="ag-theme-alpine" [localeText]="customLocaleText">
            </ag-grid-angular>
        </div>
        <div *ngIf="sensoriToDettaglioTabella.length == 0;" class="card">
            <div class="card-header">
                <span class="mb-2" style="font-size: 1rem;">Elenco dei Sensori</span>
            </div>
            <div class="sensor-list" style="min-height: 50px; max-height: 450px;">
                <span>Non sono stati trovati sensori associati a questa stazione</span>
            </div>
            <!-- <div class="card-footer">
                <span class="mb-2" style="font-size: 1rem;"><strong> </strong></span>
            </div> -->
        </div>

    </div>
    <div class="pt-3 modal-footer d-flex justify-content-end">
        <button class="btn btn-danger" (click)="closeSingleModal(modal)">
            <span class="h5 m-1">Chiudi</span>
        </button>
    </div>
</ng-template>

<!-- Subgiornalieri -->
<ng-template #formSubGiornalieri>
    <form class="w-100" [formGroup]="estrazioneSubForm" id="estrazioneSubForm">
        <div class="pickers flex-column p-2 w-100">
            <!-- <span class="label-sezione"><strong>Seleziona periodo di estrazione:</strong></span> -->
            <div class="row m-0 w-100 d-flex">
                <div class="datepicker-container col-sm-12 col-md-6 p-0 pr-md-1">
                    <div class="form-group">
                        <label for="dataDa" class="label-estrazione">Data da <span class="text-danger">*</span></label>
                        <div class="w-100">
                            <input id="dataDa" class="form-control datetimepicker"
                                placeholder="Seleziona una data di inizio" name="dp" ngbDatepicker #dp3="ngbDatepicker"
                                (click)="dp3.toggle()" formControlName="dataDaSub" [maxDate]="maxSelectableDate"
                                (dateSelect)="onDataDaSubChange()" />
                        </div>
                    </div>
                </div>

                <div class="datepicker-container col-sm-12 col-md-6 p-0 pl-md-1">
                    <div class="form-group">
                        <label for="dataA" class="label-estrazione">Data a <span class="text-danger">*</span></label>
                        <div class="w-100">
                            <input id="dataA" class="form-control datetimepicker"
                                placeholder="Seleziona una data di fine" name="dp2" ngbDatepicker #dp4="ngbDatepicker"
                                (click)="dp4.toggle()" formControlName="dataASub"
                                [disabled]="this.estrazioneSubForm.get('dataDaSub').value == null"
                                [minDate]="this.estrazioneSubForm.get('dataDaSub').value" [maxDate]="finalMaxDateSub" />
                        </div>
                    </div>
                </div>
            </div>

            <span class="w-100" style="font-size: 12px; font-style: italic;opacity: 0.9;">Seleziona l'intervallo del quale vuoi eseguire l'estrazione. Tale intervallo non può essere superiore ad 1 anno.</span>
        </div>
        <div class="pickers flex-column p-2 w-100 border-top">
            <div class="row m-0 w-100 d-flex">
                <div class="d-flex col-md-6 col-sm-12 p-0 pr-md-1">
                    <div class="form-group col p-0">
                        <label class="label-estrazione" for="select-tipo-ente">Tipologia ente <span
                                class="text-danger">*</span></label>
                        <select class="form-control" id="select-tipo-ente" aria-label="Seleziona un tipo ente"
                            formControlName="tipoEnteEstrazione">
                            <option style="color: #E3E3E3;" value="" disabled selected hidden>Seleziona tipo ente
                            </option>
                            <option value="Enti Pubblici">Enti Pubblici</option>
                            <option value="Società Private">Società Private</option>
                            <option value="Soggetti Privati">Soggetti Privati</option>
                            <option value="Studi Privati">Studi Privati</option>
                            <option value="Fondazioni/ONLUS/RTI/Società a prevalente capitale pubblico">
                                Fondazioni/ONLUS/RTI/Società a prevalente capitale pubblico</option>
                            <option value="Altro">Altro</option>
                        </select>
                    </div>
                    <div class="form-group d-flex flex-column col p-0 pl-1"
                        *ngIf="this.estrazioneSubForm.get('tipoEnteEstrazione').value == 'Altro'">
                        <label for="altro" class="label-estrazione">Ente alternativo <span
                                class="text-danger">*</span></label>
                        <div>
                            <input type="text" class="form-control" id="altro" aria-describedby=" "
                                placeholder="Inserisci ente alternativo" formControlName="altroEnte">
                        </div>
                    </div>
                </div>
                <div class="d-flex col-md-6 col-sm-12 p-0 pl-md-1">
                    <div class="form-group col p-0 pr-1">
                        <label class="label-estrazione d-flex" for="select-tipo-ente">Motivazione <button type="button"
                                class="info-tps" placement="top"
                                ngbTooltip="Le informazioni richieste sono necessarie ai fini della verifica e monitoraggio dell’erogazione del servizio e saranno utilizzate dal Centro Funzionale esclusivamente nell’ambito delle procedure interne di analisi statistica della domanda/richiesta dell’utenza e mappatura delle categorie di stake-holders">(i)</button>
                            <span class="text-danger">*</span></label>
                        <select class="form-control" id="select-tipo-ente" aria-label="Seleziona una motivazione"
                            formControlName="motivazioneEstrazione">
                            <option style="color: #E3E3E3;" value="" disabled selected hidden>Seleziona motivazione
                            </option>
                            <option value="Studio/Ricerca">Studio/Ricerca</option>
                            <option value="Lavoro">Lavoro</option>
                            <option value="Hobby/Interessi personali">Hobby/Interessi personali</option>
                            <option value="Altro">Altro</option>
                        </select>
                    </div>
                    <div class="form-group d-flex flex-column col p-0 pl-1"
                        *ngIf="this.estrazioneSubForm.get('motivazioneEstrazione').value == 'Altro'">
                        <label for="altro" class="label-estrazione">Motivazione alternativa <span
                                class="text-danger">*</span></label>
                        <div>
                            <input type="text" class="form-control" id="altro" aria-describedby=" "
                                placeholder="Inserisci una motivazione alternativa" formControlName="altraMotivazione">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pickers flex-column p-2 w-100 border-top">
            <div class="row m-0 w-100 d-flex">
                <div class="d-flex col-md-4 col-sm-12 p-0 pr-md-1">
                    <div class="form-group d-flex flex-column w-100">
                        <label for="emailToDownload" class="label-sezione">Email <span
                                class="text-danger">*</span></label>
                        <input type="email" class="form-control" id="emailToDownload" aria-describedby="emailHelp"
                            placeholder="Inserisci la tua mail" formControlName="email">
                    </div>
                    <!-- <span class="pt-1" style="font-size: 12px; font-style: italic;opacity: 0.9;">
                        Inserisci la mail su cui ricevere l'estrazione
                    </span> -->
                </div>
                <div class="d-flex col-md-4 col-sm-12 p-0 px-md-1">
                    <div class="form-group d-flex flex-column w-100">
                        <label for="nome" class="label-estrazione">Nome</label>
                        <div>
                            <input type="text" class="form-control" id="nome" aria-describedby=" " placeholder="Nome"
                                formControlName="nome">
                        </div>
                    </div>
                </div>
                <div class="d-flex col-md-4 col-sm-12 p-0 pr-md-1">
                    <div class="form-group d-flex flex-column w-100">
                        <label for="cognome" class="label-estrazione">Cognome</label>
                        <div>
                            <input type="text" class="form-control" id="cognome" aria-describedby=" "
                                placeholder="Cognome" formControlName="cognome">
                        </div>
                    </div>
                </div>
            </div>
            <span class="pt-1 w-100" style="font-size: 12px; font-style: italic;opacity: 0.9;">I tuoi dati saranno
                trattati in conformità con la nostra
                <a href="disclaimer/privacy" target="_blank" class="fw-bold" style="cursor: pointer;">Informativa
                    sulla Privacy e
                    Termini di utilizzo</a>.</span>
        </div>
        <div class="border-top p-2">
            <div class="form-check pl-0 d-flex justify-content-center align-items-center">
                <div class="terminiCheck">
                    <label class="form-check-label">
                        <input class="form-check-input" id="termsAccepted" type="checkbox"
                            formControlName="termsAccepted">
                        <span class="form-check-sign"></span>
                        Accetto i <a style="cursor: pointer; margin-left:6px;"> termini di utilizzo <span class="text-danger">*</span></a>
                    </label>
                </div>
            </div>
        </div>
        <div class="pt-3 mt-2 modal-footer d-flex justify-content-between border-top flex-wrap">
            <div class="col-sm-12 ">
                <p class="text-danger">I campi contrassegnati da * sono obbligatori</p>
            </div>
            <div class="col-sm-12 d-flex justify-content-end">
                <button class="btn btn-info m-0 mr-2" 
                        [disabled]="isButtonDisabled || isLoadingEstraiDatiSub"
                        [class.btn-secondary]="isButtonDisabled || isLoadingEstraiDatiSub"
                        (click)="estraiDatiSubgiornalieri()">
                    <span class="h5 m-1">
                        <i *ngIf="isLoadingEstraiDatiSub" class="fa fa-spinner fa-spin mr-2"></i>
                        {{ isLoadingEstraiDatiSub ? 'Invio in corso...' : (isButtonDisabled ? 'Attendere...' : 'Conferma estrazione') }}
                    </span>
                </button>
                <button class="btn btn-danger m-0" (click)="closeAllModal()">
                    <span class="h5 m-1">Chiudi</span>
                </button>
            </div>
        </div>
    </form>
</ng-template>

<!-- Giorn -->
<ng-template #consultazioneGiornalieri>
    <div class="w-100">
        <div class="pickers flex-column p-2 w-100">
            <div class="w-100 d-flex align-items-center">
                <span class="h5"><strong>Visualizzazione dati giornalieri:</strong></span>
            </div>
            <div class="row m-0 w-100 d-flex">
                <div class="datepicker-container col-sm-12 col-md-6 p-0 pr-md-1">
                    <div class="form-group">
                        <label for="dataDa" class="label-estrazione">Data da <span class="text-danger">*</span></label>
                        <div class="w-100">
                            <input id="dataDa" class="form-control datetimepicker"
                                placeholder="Seleziona una data di inizio" name="dp" ngbDatepicker #dp5="ngbDatepicker"
                                (click)="dp5.toggle()" [(ngModel)]="dateConsultazione.from" [maxDate]="maxSelectableDate"
                                (ngModelChange)="onFromDateChange()" />
                        </div>
                    </div>
                </div>

                <div class="datepicker-container col-sm-12 col-md-6 p-0 pl-md-1">
                    <div class="form-group">
                        <label for="dataA" class="label-estrazione">Data a <span class="text-danger">*</span></label>
                        <div class="w-100">
                            <input id="dataA" class="form-control datetimepicker"
                                placeholder="Seleziona una data di fine" name="dp2" ngbDatepicker #dp6="ngbDatepicker"
                                (click)="dp6.toggle()" [(ngModel)]="dateConsultazione.to"
                                (ngModelChange)="resetConsultaState()"
                                [minDate]="dateConsultazione.from" [maxDate]="finalMaxDate"
                                [disabled]="dateConsultazione.from == null" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-100 d-flex justify-content-between align-item-center flex-wrap">
                <span style="font-size: 12px; font-style: italic;opacity: 0.9;">Seleziona l'intervallo del
                    quale vuoi eseguire la consultazione. Tale intervallo non può essere superiore ad 1 anno.</span>
                <button class="btn btn-info m-0 mr-2" 
                        [disabled]="isConsultaDisabled || isLoadingConsultaDati"
                        [class.btn-secondary]="isConsultaDisabled || isLoadingConsultaDati"
                        (click)="consultaDati()">
                    <span class="h5 m-1">
                        <i *ngIf="isLoadingConsultaDati" class="fa fa-spinner fa-spin mr-2"></i>
                        <i *ngIf="isConsultaDisabled && !isLoadingConsultaDati" class="fa fa-check mr-2" style="color: #28a745;"></i>
                        {{ isLoadingConsultaDati ? 'Caricamento...' : (isConsultaDisabled ? 'Richiesta effettuata' : 'Conferma invio') }}
                    </span>
                </button>
            </div>
        </div>
        <div class="w-100 p-2 border-top" *ngIf="datiConsultazioneGiorn">
            <!-- Controlli personalizzati per la paginazione della tabella di consultazione -->
            <div class="d-flex align-items-center justify-content-between mb-2">
                <div class="d-flex align-items-center">
                    <label class="mr-2 mb-0">Righe per pagina:</label>
                    <select class="form-control" style="width: auto;" [(ngModel)]="currentPageSizeConsultazione"
                        (change)="changePageSizeConsultazione($event.target.value)">
                        <option *ngFor="let size of pageSizeOptionsConsultazione" [value]="size">{{size}}</option>
                    </select>
                </div>
                <div class="text-muted">
                    Totale record: {{datiConsultazioneGiorn?.length || 0}}
                </div>
            </div>
            
            <ag-grid-angular [rowData]="datiConsultazioneGiorn" [gridOptions]="gridOptionsConsultazione"
                style="height: 600px; width: 100%;" class="ag-theme-alpine" [localeText]="customLocaleText">
            </ag-grid-angular>
        </div>
        <div class="pt-3 mt-2 modal-footer d-flex justify-content-between border-top">
            <div class="w-100 d-flex justify-content-end">
                <button class="btn btn-danger m-0" (click)="closeAllModal()">
                    <span class="h5 m-1">Chiudi</span>
                </button>
            </div>
        </div>
    </div>

</ng-template>
<!-- Giorn estr -->
<ng-template #formGiornalieri>
    <form [formGroup]="dataForm" id="dataForm">
        <div class="w-100">
            <!-- Date -->
            <div class="pickers d-flex flex-column align-item-center w-100 p-2">
                <!-- <span class="label-sezione"><strong>Seleziona periodo di estrazione:</strong></span> -->
                <div class="row m-0 w-100">
                    <div class="datepicker-container col-sm-12 col-md-6 p-0 pr-md-1">
                        <div class="form-group">
                            <label for="dataDa" class="label-estrazione">Data da <span
                                    class="text-danger">*</span></label>
                            <div class="pr-2">
                                <input id="dataDa" class="form-control datetimepicker"
                                    placeholder="Seleziona una data di inizio" name="dp" ngbDatepicker
                                    #dp1="ngbDatepicker" (click)="dp1.toggle()" formControlName="dataDaGiornalieri"
                                    [maxDate]="maxSelectableDate" (dateSelect)="onDataDaGiornalieriChange()" />
                            </div>
                        </div>
                    </div>

                    <div class="datepicker-container col-sm-12 col-md-6 p-0 pl-md-1">
                        <div class="form-group">
                            <label for="dataA" class="label-estrazione">Data a <span
                                    class="text-danger">*</span></label>
                            <div class="pl-2">
                                <input id="dataA" class="form-control datetimepicker"
                                    placeholder="Seleziona una data di fine" name="dp2" ngbDatepicker
                                    #dp2="ngbDatepicker" (click)="dp2.toggle()" formControlName="dataAGiornalieri"
                                    [minDate]="this.dataForm.get('dataDaGiornalieri').value"
                                    [maxDate]="finalMaxDateGiornalieri"
                                    [disabled]="this.dataForm.get('dataDaGiornalieri').value == null" />
                            </div>
                        </div>
                    </div>
                </div>

                <span class="w-100" style="font-size: 12px; font-style: italic;opacity: 0.9;">Seleziona l'intervallo del quale vuoi eseguire l'estrazione. Tale intervallo non può essere superiore ad 1 anno.</span>
        
            </div>
        </div>
        <div class="pickers flex-column p-2 w-100 border-top">
            <div class="row m-0 w-100 d-flex">
                <div class="d-flex col-md-4 col-sm-12 p-0 pr-md-1">
                    <div class="form-group d-flex flex-column w-100">
                        <label for="emailToDownload" class="label-sezione">Email <span
                                class="text-danger">*</span></label>
                        <input type="email" class="form-control" id="emailToDownload" aria-describedby="emailHelp"
                            placeholder="Inserisci la tua mail" formControlName="email">
                    </div>
                    <!-- <span class="pt-1" style="font-size: 12px; font-style: italic;opacity: 0.9;">
                            Inserisci la mail su cui ricevere l'estrazione
                        </span> -->
                </div>
                <div class="d-flex col-md-4 col-sm-12 p-0 px-md-1">
                    <div class="form-group d-flex flex-column w-100">
                        <label for="nome" class="label-estrazione">Nome</label>
                        <div>
                            <input type="text" class="form-control" id="nome" aria-describedby=" " placeholder="Nome"
                                formControlName="nome">
                        </div>
                    </div>
                </div>
                <div class="d-flex col-md-4 col-sm-12 p-0 pr-md-1">
                    <div class="form-group d-flex flex-column w-100">
                        <label for="cognome" class="label-estrazione">Cognome</label>
                        <div>
                            <input type="text" class="form-control" id="cognome" aria-describedby=" "
                                placeholder="Cognome" formControlName="cognome">
                        </div>
                    </div>
                </div>
            </div>
            
            <span class="pt-1 w-100" style="font-size: 12px; font-style: italic;opacity: 0.9;">I tuoi dati saranno
                trattati in conformità con la nostra 
                <a href="disclaimer/privacy" target="_blank" class="fw-bold" style="cursor: pointer;">Informativa sulla Privacy e Termini di utilizzo</a>.</span>
        </div>
        <div class="border-top p-2">
            <div class="form-check pl-0 d-flex justify-content-center align-items-center">
                <div class="terminiCheck">
                    <label class="form-check-label">
                        <input class="form-check-input" id="termsAccepted" type="checkbox"
                            formControlName="termsAccepted">
                        <span class="form-check-sign"></span>
                        Accetto i <a style="cursor: pointer; margin-left:6px;" (click)="routeTo('disclaimer/privacy')"> termini di utilizzo</a><span class="text-danger">*</span>
                    </label>
                </div>
            </div>
        </div>
        <div class="pt-3 mt-2 modal-footer d-flex justify-content-between border-top flex-wrap">
            <div class="col-sm-12 ">
                <p class="text-danger">I campi contrassegnati da * sono obbligatori.</p>
            </div>
            <div class="col-sm-12 d-flex justify-content-end">
                <button class="btn btn-info m-0 mr-2" 
                        [disabled]="isButtonDisabled || isLoadingEstraiDati"
                        [class.btn-secondary]="isButtonDisabled || isLoadingEstraiDati"
                        (click)="estraiDati()">
                    <span class="h5 m-1">
                        <i *ngIf="isLoadingEstraiDati" class="fa fa-spinner fa-spin mr-2"></i>
                        {{ isLoadingEstraiDati ? 'Invio in corso...' : (isButtonDisabled ? 'Attendere...' : 'Conferma estrazione') }}
                    </span>
                </button>
                <button class="btn btn-danger m-0" (click)="closeAllModal()">
                    <span class="h5 m-1">Chiudi</span>
                </button>
            </div>
        </div>
    </form>
</ng-template>